import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {ISetting} from '../../shared/model/setting.model';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';


type EntityResponseType = HttpResponse<ISetting>;
type EntityArrayResponseType = HttpResponse<ISetting[]>;

@Injectable({ providedIn: 'root' })
export class SettingService {
    public resourceUrl = SERVER_API_URL + 'api/setting-package';

    constructor(protected http: HttpClient) {}

    create(setting: ISetting): Observable<EntityResponseType> {
        return this.http.post<ISetting>(this.resourceUrl, setting, { observe: 'response' });
    }

    update(setting: ISetting): Observable<EntityResponseType> {
        return this.http.put<ISetting>(this.resourceUrl, setting, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<ISetting>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    findByEmployee(id: number): Observable<EntityResponseType> {
        return this.http.get<ISetting>(`${this.resourceUrl+'-employee'}/${id}`, { observe: 'response' });
    }

    findGeneral(): Observable<EntityResponseType> {
        return this.http.get<ISetting>(`${this.resourceUrl+'-general'}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<ISetting[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
}
